module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ote_logo_white.6fc56ec7.svg";